import { render, staticRenderFns } from "./NavigationBarLink.vue?vue&type=template&id=665d8c9c"
import script from "./NavigationBarLink.vue?vue&type=script&lang=js"
export * from "./NavigationBarLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports